export default {
    props: {
        list: Array,
    },

    methods: {
        // 跳转到详情页
        linkToDetail(data) {
            const { extension } = data || {};
            const { url, pcUrl } = extension || {};
            const link = data.url || pcUrl || url;
            
            link ? window.document.location.href = link : '';
        },
    }
}
